import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	Pagination
} from 'element-ui';

import {
	cloneDeep
} from 'lodash';

export default {
	name: 'received-messages',
	components: {
		Pagination
	},
	data: () => ({
		payloadFilter: {}
	}),
	computed: {
		...mapGetters({
			settings: 'settings',
			loggedUser: 'getLoggedUser',
			receivedMessages: 'getReceivedMessageList',
			inboxReceivedFilter: 'inboxReceivedFilter'
		})
	},
	methods: {
		...mapActions([
			'getReceivedMessages'
		]),
		handleCurrentChange(page) {

			this.payloadFilter.pagination = {
				quantity: this.settings.Pagination.pageSize,
				page: (page - 1)
			};

			this.getReceivedMessages(this.payloadFilter);
		}
	},
	mounted() {

		this.payloadFilter = {
			data: this.loggedUser,
			filter: cloneDeep(this.inboxReceivedFilter),
			pagination: {
				quantity: this.settings.Pagination.pageSize,
				page: 0
			}
		};

		this.getReceivedMessages(this.payloadFilter);

	}
};



// WEBPACK FOOTER //
// ./sources/domains/inbox/message-received/list/index.js